<template>
  <div>
    <div class="row my-3">
      <div class="col-12">
        <full-calendar
          :event-sources="eventSources"
          :config="config" ref="calendar"
          @event-created="daysSelected"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { FullCalendar } from 'vue-full-calendar';

export default {
  name: 'TrucksCalendar',
  components: {
    FullCalendar,
  },
  data() {
    return {
      saving: false,
      eventSources: this.fetchEvents(),
      config: {
        weekends: true,
        firstDay: 1,
        editable: false,
        slotEventOverlap: false,
        defaultView: 'month',
        displayEventTime: false,
        selectable: true,
        header: {
          left: 'prev',
          center: 'title',
          right: 'next',
        },
      },
      selectedDays: {
        dateFrom: null,
        dateTo: null,
      },
    };
  },
  methods: {
    daysSelected(event) {
      this.selectedDays.dateFrom = event.start.format('MM/DD/YYYY');
      this.selectedDays.dateTo = event.end.format('MM/DD/YYYY');
      if (this.saving === false) {
        this.saving = true;
        axios
          .post(`trucks/${this.$route.params.id}/unavailability`, {
            date_from: moment(this.selectedDays.dateFrom).format('MM/DD/YYYY'),
            date_to: moment(this.selectedDays.dateTo).format('MM/DD/YYYY'),
          })
          .then(() => {
            this.$refs.calendar.$emit('refetch-events');
          })
          .catch(err => this.errors.record(err.response.data.error));
        this.saving = false;
      }
    },
    fetchEvents() {
      const vm = this;
      return [
        {
          events(start, end, timezone, callback) {
            axios
              .get(
                `trucks/${vm.$route.params.id}/unavailability?date_from=${start.format(
                  'MM/DD/YYYY',
                )}&date_to=${end.format('MM/DD/YYYY')}`,
              )
              .then(response => {
                response.data.forEach(el => {
                  if (el.job_id) {
                    const element = el;
                    element.title += `: ${el.job_ref_id}`;
                    element.url = `/jobs/edit/${el.job_id}`;
                  }
                });
                callback(response.data);
              })
              .catch(err => this.errors.record(err.response.data.error));
          },
          color: 'blue',
          textColor: 'white',
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/trucks/TrucksCalendar.vue